var _path, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPromotionBannerEve(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 58,
    viewBox: "0 0 120 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "Promotion_banner_Eve_svg__a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 120,
    height: 58
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h120v58H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#Promotion_banner_Eve_svg__a)",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.99 46.019c.493 20.015-15.892 36.626-36.596 37.103-20.705.477-37.89-15.36-38.383-35.375-.494-20.015 15.89-36.627 36.595-37.104 20.705-.477 37.89 15.361 38.383 35.376",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.956 36.016C94.332 25.803 84.378 18.097 72.48 18.374l-1.96.046c-14.445.337-25.868 12.449-25.512 27.052l.173 7.102c.275 11.262 9.528 20.18 20.668 19.921l13.93-.325c3.24-.076 6.283-.92 8.962-2.355 3.327-1.782 6.141-4.8 7.886-8.146 3.134-6.013 5.051-15.16 1.329-25.653",
    fill: "#C2DDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.233 27.232c-11.023-4.26-30.522-1.401-38.095 2.918a26.639 26.639 0 00-3.172 6.902l-2.55.06c-1.366.03-2.448 1.133-2.415 2.46l.374 15.239c.032 1.327 1.166 2.378 2.533 2.346l1.752-.04c2.248 9.017 10.304 15.596 19.736 15.377l15.935-.369c7.6-.238 12.216-5.887 12.216-5.887 1.633-4.161 2.561-11.863 2.443-16.683-.222-9.059-3.1-16.519-8.757-22.323",
    fill: "#FFF3E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.564 20.305c-3.046.072-9.31.665-12.624 2.029-1.78.732-2.985 2.45-2.939 4.391.062 2.589 2.342 4.635 5.092 4.57a5.161 5.161 0 002.992-1.03c1.707 1.638 4.565 2.675 7.78 2.599 5.127-.122 9.217-3.033 9.134-6.5-.083-3.469-4.307-6.181-9.435-6.06",
    fill: "#F9D534"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94 28.324a26.297 26.297 0 00-21.245-9.95l-1.964.045A26.19 26.19 0 0049 30.934c7.717-2.388 16.439-3.833 25.698-4.045 6.75-.154 13.245.36 19.302 1.435",
    fill: "#62A8FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.662 49.3c-.363 0-.659-.347-.662-.778-.003-.434.29-.788.656-.791l.793-.008-.573-2.244c-.106-.415.091-.853.441-.979.35-.124.72.11.825.524l.83 3.248a.906.906 0 01-.1.693.635.635 0 01-.528.32l-1.677.015h-.005zM78.338 54.134c-2.506 0-4.792-.887-6.152-2.396a.708.708 0 01.093-1.04.822.822 0 011.108.087c1.081 1.2 3.05 1.922 5.152 1.87 2.096-.046 4.031-.85 5.05-2.099a.82.82 0 011.103-.136c.345.248.41.712.145 1.035-1.321 1.618-3.662 2.618-6.26 2.677l-.24.002M86 46.4c-1.105 0-2-.808-2-1.804v-2.192c0-.997.895-1.804 2-1.804s2 .807 2 1.804v2.192c0 .996-.895 1.804-2 1.804M67 46.4c-1.105 0-2-.808-2-1.804v-2.192c0-.997.895-1.804 2-1.804s2 .807 2 1.804v2.192c0 .996-.895 1.804-2 1.804M69.258 39.632c-.194 0-.389-.098-.534-.293-.668-.896-1.775-.923-2.468-.06-.295.366-.764.355-1.049-.026-.284-.382-.275-.988.02-1.356 1.283-1.595 3.33-1.546 4.566.112.284.381.275.988-.02 1.355a.662.662 0 01-.515.268M88.258 39.632c-.193 0-.387-.097-.532-.291-.67-.896-1.777-.917-2.468-.048-.293.37-.763.36-1.049-.02-.285-.382-.278-.99.016-1.36 1.278-1.608 3.326-1.568 4.566.088.285.381.278.99-.016 1.36a.662.662 0 01-.517.271",
    fill: "#308CFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.461 29.072c-2.918.467-4.88 3.075-4.384 5.824l.282 2.467c.496 2.749 3.263 4.599 6.18 4.131 2.918-.467 4.88-3.074 4.384-5.823l-.282-2.467c-.496-2.75-3.263-4.6-6.18-4.132",
    fill: "#62A8FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.771 33.092c-.757.444-.997 1.395-.538 2.126l2.795 4.638c.459.73 1.445.963 2.201.52.757-.444.997-1.395.538-2.126l-2.795-4.639c-.459-.73-1.445-.962-2.201-.519",
    fill: "#62A8FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.382 82.167c-.887 0-1.754-.065-2.595-.2-3.118-.498-5.226-3.338-4.709-6.342.517-3.004 3.465-5.034 6.583-4.537 1.895.302 6.475-.713 10.694-4.726 2.667-2.537 4.632-5.723 5.839-9.47 1.481-4.591 1.76-9.888.831-15.743-.478-3.01 1.668-5.824 4.792-6.284 3.123-.46 6.045 1.607 6.523 4.617 2.247 14.157-1.284 26.49-9.942 34.728-5.258 5.002-12.069 7.957-18.016 7.957",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.537 58.257c1.563.611-1.208 5.13-2.771 4.52-1.563-.611-2.21-2.119-1.444-3.367.765-1.248 2.652-1.764 4.215-1.153",
    fill: "#62A8FD"
  }))));
}

export default __webpack_public_path__ + "a0f81523.svg";
export { SvgPromotionBannerEve as ReactComponent };